module.exports = __webpack_public_path__ + "static/romanis-ba49b736cccd7009a2becbc6b6db9d63.png";